import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  location: 'Madrid, España'
}, {
  name: 'Sarah T.',
  location: 'Austin, TX'
}, {
  name: 'Laura M.',
  location: 'Ciudad de México'
}, {
  name: 'Jessica R.',
  location: 'Miami, FL'
}, {
  name: 'Ana P.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Emily W.',
  location: 'London, UK'
}, {
  name: 'Camila S.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Rachel K.',
  location: 'Toronto, Canada'
}, {
  name: 'Valentina L.',
  location: 'Santiago, Chile'
}, {
  name: 'Sophie B.',
  location: 'Sydney, Australia'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // Show first popup after 8 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    const interval = setInterval(() => {
      setVisible(true);
      setCurrentIndex(prev => (prev + 1) % buyers.length);
    }, 20000);
    return () => clearInterval(interval);
  }, [dismissed]);
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  const buyer = buyers[currentIndex];
  const minutesAgo = Math.floor(Math.random() * 12) + 1;
  if (dismissed) return null;
  return <AnimatePresence data-id="element-131">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-lg border border-gray-200 flex items-center gap-3 p-3 pr-4 max-w-xs" data-id="element-132">
          <img src="https://cdn.magicpatterns.com/uploads/k2BoNvCKS3rrSAGUdrUT45/heylloyd-image-1772765482112.png" alt="Toddler Travel Survival Kit" className="w-12 h-12 rounded-lg object-cover shrink-0" data-id="element-133" />
          <div className="min-w-0" data-id="element-134">
            <p className="text-sm font-bold text-brand-dark leading-tight truncate" data-id="element-135">
              {buyer.name}
            </p>
            <p className="text-xs text-gray-500 leading-tight" data-id="element-136">
              compró el Survival Kit —{' '}
              <span className="font-semibold text-brand-orange" data-id="element-137">$6.39</span>
            </p>
            <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-138">
              hace {minutesAgo} min · {buyer.location}
            </p>
          </div>
          <button onClick={() => setDismissed(true)} className="absolute -top-1.5 -right-1.5 bg-gray-100 rounded-full p-0.5 hover:bg-gray-200 transition-colors" data-id="element-139">
            <XIcon className="w-3 h-3 text-gray-400" data-id="element-140" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}